module.exports = __webpack_public_path__ + "b449e075d6d658aa282e5535cc70a757.svg";